// extracted by mini-css-extract-plugin
export default {"sections":"ActivitySections_sections__dYgvI"};